var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 77,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 171,
    width: 96,
    height: 77
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-35 -171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.375 211.727C125.625 216.182 125.625 216.182 125.625 216.182 125.625 216.182 125 216.182 125 216.818 124.375 216.818 124.375 216.818 124.375 216.818 123.75 216.818 123.75 216.182 123.125 216.182 82.5 181.182 82.5 181.182 82.5 181.182 41.25 216.182 41.25 216.182 41.25 216.182 41.25 216.182 40.625 216.818 40 216.818 39.375 216.182 39.375 216.182 38.75 216.182 35 211.727 35 211.727 35 211.727 35 211.091 35 210.455 35 209.818 35 209.182 35 209.182 35.625 208.545 78.125 172.909 78.125 172.909 78.125 172.909 79.375 171.636 80.625 171 82.5 171 84.375 171 85.625 171.636 86.875 172.909 101.25 185 101.25 185 101.25 185 101.25 172.909 101.25 172.909 101.25 172.909 101.25 172.909 101.25 172.273 101.875 171.636 101.875 171.636 102.5 171 103.125 171 114.375 171 114.375 171 114.375 171 115 171 115.625 171.636 115.625 171.636 116.25 172.273 116.25 172.909 116.25 172.909 116.25 197.727 116.25 197.727 116.25 197.727 129.375 208.545 129.375 208.545 129.375 208.545 130 209.182 130 209.182 130 209.818 130 210.455 130 211.091 129.375 211.727ZM116.25 215.545C116.25 244.182 116.25 244.182 116.25 244.182 116.25 245.455 116.25 246.091 115 247.364 114.375 248 113.75 248 112.5 248 90 248 90 248 90 248 90 225.091 90 225.091 90 225.091 75 225.091 75 225.091 75 225.091 75 248 75 248 75 248 51.875 248 51.875 248 51.875 248 51.25 248 50 248 49.375 247.364 48.75 246.091 48.125 245.455 48.125 244.182 48.125 215.545 48.125 215.545 48.125 215.545 48.125 215.545 48.125 215.545 48.125 215.545 48.125 215.545 48.125 215.545 48.125 214.909 82.5 186.909 82.5 186.909 82.5 186.909 116.25 214.909 116.25 214.909 116.25 214.909 116.25 215.545 116.25 215.545 116.25 215.545Z",
    fill: "#333",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9d357de02f5ace59407633fa66a859e3.svg";
export { ForwardRef as ReactComponent };